var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrectSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.746 20.3036L19.1685 23.7261L26.0135 16.8811M36.2809 20.3036C36.2809 22.3261 35.8826 24.3288 35.1086 26.1973C34.3346 28.0659 33.2002 29.7637 31.77 31.1939C30.3399 32.624 28.6421 33.7584 26.7735 34.5324C24.905 35.3064 22.9022 35.7048 20.8797 35.7048C18.8572 35.7048 16.8545 35.3064 14.9859 34.5324C13.1174 33.7584 11.4196 32.624 9.98943 31.1939C8.55929 29.7637 7.42485 28.0659 6.65086 26.1973C5.87688 24.3288 5.47852 22.3261 5.47852 20.3036C5.47852 16.2189 7.10114 12.3015 9.98943 9.41326C12.8777 6.52497 16.7951 4.90234 20.8797 4.90234C24.9644 4.90234 28.8817 6.52497 31.77 9.41326C34.6583 12.3015 36.2809 16.2189 36.2809 20.3036Z",
    stroke: "#2C4657",
    strokeWidth: 3.42249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectSvg);
export default __webpack_public_path__ + "static/media/correct-svg.a730c1caa397d57b3c988090d093e563.svg";
export { ForwardRef as ReactComponent };